/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener-intake
 * crm-screener-intake
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface BidirectionalActionConfigPhoneNumber
 */
export interface BidirectionalActionConfigPhoneNumber {
    /**
     * 
     * @type {string}
     * @memberof BidirectionalActionConfigPhoneNumber
     */
    name: string;
    /**
     * 
     * @type {boolean}
     * @memberof BidirectionalActionConfigPhoneNumber
     */
    required: boolean;
}

/**
 * Check if a given object implements the BidirectionalActionConfigPhoneNumber interface.
 */
export function instanceOfBidirectionalActionConfigPhoneNumber(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "name" in value;
    isInstance = isInstance && "required" in value;

    return isInstance;
}

export function BidirectionalActionConfigPhoneNumberFromJSON(json: any): BidirectionalActionConfigPhoneNumber {
    return BidirectionalActionConfigPhoneNumberFromJSONTyped(json, false);
}

export function BidirectionalActionConfigPhoneNumberFromJSONTyped(json: any, ignoreDiscriminator: boolean): BidirectionalActionConfigPhoneNumber {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'name': json['name'],
        'required': json['required'],
    };
}

export function BidirectionalActionConfigPhoneNumberToJSON(value?: BidirectionalActionConfigPhoneNumber | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'name': value.name,
        'required': value.required,
    };
}

